// NRMA Parks and Resorts booking strategy.
//
// `site.reserveUrl` is the park's booking list with the category pinned
// first (`/<park>/book-now/?sticky_category=<id>`). The list page reads the
// stay and party from its own query string when `search=1` is present:
//
//   search=1&available_from=<yyyy-MM-dd>&available_to=<yyyy-MM-dd>&adults=<N>
//
// It then quotes every category for that stay and shows the pinned one on
// top with its Book button, or the park's own "Minimum N night stay" note.
// Book on a site opens the equipment-size dialog, and the cart is built
// client-side after that, so nothing deeper is addressable by URL. The
// API's own `details?force_category_id=` link renders the classic widget,
// whose Book Now returned to the bare list without the stay, so it is never
// emitted (agencies/NRMAParksResorts/proof/discovery.md, Reserve URL).

import { format } from "date-fns";
import { resolveCheckout, resolveMinCapacity } from "./_context.js";

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate } = ctx;
    const checkout = resolveCheckout(ctx);
    const adults = resolveMinCapacity(ctx);

    const url = new URL(site.reserveUrl);
    url.searchParams.set("search", "1");
    url.searchParams.set("available_from", format(arrivalDate, "yyyy-MM-dd"));
    url.searchParams.set("available_to", format(checkout, "yyyy-MM-dd"));
    url.searchParams.set("adults", String(adults));
    return url.toString();
  },

  buildPreviewUrl(site) {
    // The park's full booking list: every category, no pin.
    const url = new URL(site.reserveUrl);
    url.search = "";
    return url.toString();
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as &available_from=<yyyy-MM-dd> (with &search=1).",
        },
        departureDate: {
          status: "required",
          notes:
            "Encoded as &available_to=<yyyy-MM-dd>; resolved from arrival + minStayLength when not supplied.",
        },
        ref: {
          status: "ignored",
          notes:
            "site.reserveUrl already pins the category with &sticky_category=<id>.",
        },
        partySize: {
          status: "defaulted",
          defaultValue: 1,
          notes:
            "Encoded as &adults=<N>; defaults to AvailabilityRequest.minCapacity, then 1.",
        },
      },
    };
  },
};
